<template>
  <v-card class="h-100" variant="outlined" color="primary" :min-height="minHeight">
    <l-map
      :zoom="zoom"
      :center="center"
      style="height: 100%; width: 100%"
      :options="mapOptions"
    >
      <l-tile-layer
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        attribution="&copy; <a href='https://www.openstreetmap.org/copyright'>OpenStreetMap</a> contributors"
      />
      <l-marker :lat-lng="[geolocation?.latitude, geolocation?.longitude]" />
    </l-map>
  </v-card>
</template>

<script>
import { LMap, LTileLayer, LMarker } from "@vue-leaflet/vue-leaflet";
import "leaflet/dist/leaflet.css";
export default {
  name: "GeolocationDetails",
  props: {
    geolocation: {
      type: Object,
      required: true,
    },
    minHeight: {
      type: String,
      default: "115px",
    },
  },
  components: {
    LMarker,
    LTileLayer,
    LMap,
  },
  data() {
    return {
      mapOptions: {
        dragging: false,
        scrollWheelZoom: "center",
        doubleClickZoom: false,
      },
    };
  },
  computed: {
    center() {
      if (
        this.geolocation?.latitude !== "" &&
        this.geolocation?.longitude !== ""
      ) {
        return [this.geolocation?.latitude, this.geolocation?.longitude];
      } else {
        return [52, 0];
      }
    },
    zoom() {
      return this.center[0] === 52 && this.center[1] === 0 ? 3 : 6;
    },
  },
};
</script>
